import styled from "styled-components";
import theme from "../../../styles/theme";
 
export const ContainerModal = styled.div`
  width: calc(450px - 64px);
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: center;
  @media (${theme.devices.tablet}) {
    width: 100%;
  }
`;

export const FooterModal = styled.div`
  display: flex;
  gap: 16px;
  margin: 16px 0px 12px;
  justify-content: center;
`;
